import moment from 'moment';

export function DateTimeFormat(date) {
  if (!date) return '-';
  return moment(date).format('MM/DD/YYYY hh:mm:ss A');
}
